let lang = {
    "Chcesz zakończyć nagrywanie?": "Chcesz zakończyć nagrywanie?",
    "Po kliknięciu przycisku Nagraj CV odpowiedz na wszystkie pytania. Powodzenia!": "Po kliknięciu przycisku Nagraj CV odpowiedz na wszystkie pytania. Powodzenia!",
    "Uwaga!": "Uwaga!",
    "Pamięć przeglądarki dla tej domeny jest pełna, nie możemy zapisać wideo lokalnie. Zapisz je na naszym serwerze, aby go nie zgubić. Jeśli nie klikniesz „zapisz”, gdy odświeżysz stronę lub zamkniesz okno nagrywania, wideo może zostać utracone.": "Pamięć przeglądarki dla tej domeny jest pełna, nie możemy zapisać wideo lokalnie. Zapisz je na naszym serwerze, aby go nie zgubić. Jeśli nie klikniesz „zapisz”, gdy odświeżysz stronę lub zamkniesz okno nagrywania, wideo może zostać utracone.",
    "Save to a server": "Zapisz na serwer",
    "Ok": "Ok",
    "Proszę czekać, video jest w trakcie przetwarzania.": "Proszę czekać, video jest w trakcie przetwarzania.",
    "Video CV usunięte": "Video CV usunięte",
    "Admin": "Admin",
    "GENERAL": "PANEL STEROWANIA",
    "App": "Statystyka",
    "Users": "Użytkownicy",
    "Vacancies": "Oferty pracy",
    "Mailing list": "Wiadomości",
    "Video Template": "Video CV",
    "Hi": "Cześć",
    "Need help?": "Potrzebujesz pomocy?",
    "Please check our faq": "Sprawdź nasze często zadawane pytania",
    "FAQ": "FAQ",
    "Welcome": "Witamy",
    "Your candidates are tired of waiting for you - write them something nice!": "W panelu sterowania możesz zarządzać kandydatami, ofertami pracy, wiadomościami, pytaniami do Video CV.",
    "Go To Users": "Lista użytkowników",
    "Recorded CV": "Nagranych Video CV",
    "Active users": "Aktywnych użytkowników",
    "Total applicants": "Zarejestrowanych użytkowników",
    "Total vacancies": "Ofert pracy",
    "Vacancies closed": "Ofert archiwalnych",
    "Settings": "Ustawienia",
    "Profile": "Profil",
    "Home": "Start",
    "Logout": "Wyloguj",
    "general": "Informacje ogólne",
    "resume": "CV",
    "Profile view": "Profil",
    "Dashboard": "Panel",
    "User": "Użytkownik",
    "Account Settings": "Ustawienia",
    "Account": "Konto",
    "Update success": "Zmiany zapisane",
    "Upload photo": "Dodaj zdjęcie",
    "Allowed *.jpeg, *.jpg, *.png, *.gif": "Format *.jpeg, *.jpg, *.png, *.gif",
    "Active Profile": "Profil Aktywny",
    "Username": "Imię Nazwisko",
    "Select city": "Miejscowość",
    "Data urodzenia": "Data urodzenia",
    "Email address": "Adres mailowy",
    "Phone number": "Telefon",
    "Select category": "Kategoria",
    "Password": "Hasło",
    "About": "O mnie",
    "Save Changes": "Zapisz zmiany",
    "Edit User": "Edytuj",
    "Video": "Video CV",
    "Link": "Link",
    "Save": "Zapisz",
    "Comment": "Komentarz rekrutera",
    "Write comment": "Napisz komentarz",
    "AboutInfo": "Info",
    "Live at": "Miejscowość",
    "Category": "Kategoria",
    "Last activity": "Online",
    "Date of Bird": "Data urodzenia",
    "Resume": "CV",
    "Print": "Drukuj",
    "Zapisz PDF": "Zapisz PDF",
    "Link to video": "Link do Video CV",
    "profile": "CV",
    "video": "Video CV",
    "Video resumes": "Video CV",
    "Zgoda na opublikowanie": "Zgoda na opublikowanie",
    "Tak": "Tak",
    "Brak zgody": "Brak zgody",
    "Utworzono": "Utworzono",
    "Nagrano": "Nagrano",
    "Brak nagranego Video CV": "Brak nagranego Video CV",
    "User List": "Lista użytkowników",
    "New User": "Nowy",
    "Search user": "Wyszukaj",
    "Add users": " Wyślij wybranym",
    "selected": "wybrano",
    "Filter list": "Filtruj",
    "City": "Miejscowość",
    "Kategoria": "Kategoria",
    "Status": "Status",
    "Video CV": "Video CV",
    "Employed Through Us": "Zatrudniony",
    "Courses asystent": "Kursy asystenta",
    "Filter": "Filtruj",
    "Clear": "Wyczyść",
    "Name": "Nazwa",
    "Last activity": "Online",
    "Aktywny": "Aktywny",
    "Nieaktywny": "Nieaktywny",
    "Video status": "Video CV",
    "Dostępne": "Dostępne",
    "Do usunięcia": "Do usunięcia",
    "Usunięte": "Usunięte",
    "No video": "Brak",
    "Recorded": "Nagrane",
    "Video recorded": "Nagrane",
    "Deleted": "Usunięty",
    "Need to delete": "Do usunięcia",
    "No active": "Nieaktywny",
    "Activee": "Aktywny",
    "Select users to whom you want to send a message": "Wybierz użytkowników, do których chcesz wysłać wiadomość",
    "Delete": "Usuń",
    "Edit": "Edytuj",
    "View": "Podgląd",
    "Rows per page": "Pokaż",
    "Yes": "Tak",
    "No": "Nie",
    "Create a new user": "Utwórz nowego użytkownika",
    "is required": "Pole wymagane",
    "New user": " Nowy",
    "Vacancies List": "Lista ofert pracy",
    "New Vacancy": "Dodaj ofertę",
    "Vacancies": "Oferty pracy",
    "Company": "Firma",
    "Mail list": "Ilość wysłanych",
    "Users apply": "Aplikanci",
    "Active": "Ważna",
    "Closed": "Archiwalna",
    "MAIL": "Wiadomość",
    "Search vacancy...": "Wyszukaj...",
    "Try checking for typos or using complete words.": "Spróbuj wyszukać według kategorii lub używając niepełne słowa.",
    "No results found for": "Nie znaleziono",
    "Not found": "Nie znaleziono",
    "Miasto": "Miasto",
    "Message Add": "Dodaj wiadomość",
    "Message New": "Nowa wiadomość",
    "Action": "Rodzaj",
    "Message": "Wiadomość",
    "Przykładowy szablon oferty pracy": "Przykładowy szablon oferty pracy",
    "Nowa oferta pracy": "Nowa oferta pracy",
    "Message is required": "Wiadomość jest wymagana",
    "Url": "URL",
    "Write your url": "Wpisz URL",
    "Create": "Utwórz",
    "Write your message": "Napisz swoją wiadomość",
    "Vacancy view": "Podgląd oferty pracy",
    "Dodane": "Dodane",
    "Wynagrodzenie": "Wynagrodzenie",
    "Rodzaj umowy": "Rodzaj umowy",
    "Zatrudnienie": "Zatrudnienie",
    "Aplikanci": "Aplikanci",
    "End at ": "Wygasła ",
    "active": "Ważna",
    "Opis": "Opis",
    "Vacancy new": "Dodaj ofertę",
    "Vacancy new bread": "Nowa oferta pracy",
    "umowa o pracę": "Umowa o pracę",
    "umowa zlecenie": "Umowa zlecenie",
    "umowa o dzielo": "Umowa o dzieło",
    "Pełny etat": "Pełny etat",
    "Niepełny etat": "Niepełny etat",
    "Praktyka / staż": "Praktyka / Staż",
    "Typ umowy": "Typ umowy",
    "Wymiar pracy": "Wymiar pracy",
    "Vacancy is active": "Oferta jest ważna",
    "Write something": "Napisz ",
    "Mailing list": "Wiadomości",
    "Messages List": "Lista wiadomości",
    "Messages": "Wiadomości",
    "New message": "Dodaj",
    "Search message": "Wyszukaj",
    "Date": "Data",
    "Users send": "Liczba",
    "Sending": "Wysłana",
    "Whait for sending": "Przetwarzanie",
    "Message View": "Podgląd wiadomości",
    "New message": "Dodaj",
    "New": "Nowa",
    "Old": "Dostarczona",
    "Namei": "Imię",
    "Nagraj Video CV": "Nagraj Video CV",
    "Sprawdź status": "Sprawdź status",
    "Zaktualizuj swój profil": "Zaktualizuj swój profil",
    "Write your message": "Napisz swoją wiadomość",
    "Message is required": "Wiadomość jest wymagana",
    "Create success": "Pomyślnie utworzono",
    "Add users to mail": "Wyślij wybranym",
    "Wiadomość wysłana": "Wiadomość wysłana",
    "Video templates List": "Listy przykładowych pytań",
    "Video templates": "Video CV",
    "New Video template": "Nowa lista",
    "Base": "Główny",
    "Template": "Szablon",
    "Video template new": "Nowa lista",
    "Question": "Pytanie",
    "Time": "Czas",
    "Position": "Numer pytania",
    "Write question": "Napisz pytanie",
    "Write time for question": "Wpisz czas na odpowiedź",
    "Write position 0-100": "Wpisz numer pytania 0-100",
    "Add": "Dodaj",
    "sec": "sec",
    "Save All": "Zapisz",
    "Is Base Template?": "Wzór główny?",
    "Text": "Treść",
    "Write your text": "Napisz treść wiadomości",
    "Text is required": "Treść widomości jest wymagana",
    "user": "Kandydat",
    "MANAGEMENT": "PANEL STEROWANIA",
    "Hi, Welcome Back": "Zapraszamy do naszej społeczności!",
    "Get started": "Zarejestruj się",
    "Don’t have an account?": "Nie masz konta?",
    "Login": "Zaloguj sie",
    "Sign in to": "Zaloguj się do Asystent.biz",
    "Enter your details below.": "Wpisz swoje dane poniżej.",
    "Email is required": "Pole wymagane",
    "Password is required": "Pole wymagane",
    "Email address": "Adres mailowy",
    "Password": "Hasło",
    "Remember me": "Zapamiętaj mnie",
    "Forgot password?": "Zapomniałeś hasła?",
    "Get an account for free.": "Załóż konto.",
    "Manage the job more effectively": "Skutecznie szukaj nowej pracy z Asystent.biz",
    "Already have an account?": "Posiadasz już konto?",
    "Register": "Rejestracja",
    "By registering, I agree to": "Potwierdzam zapoznanie się z",
    "and": "i",
    "przetwarzanie": "Wyrażam zgodę na przetwarzanie i udostępnienie moich danych osobowych.",
    "Terms of Service": "Regulaminem",
    "Privacy Policy": "Polityką Prywatności",
    "Logini": "Logowanie",
    "First name": "Imię",
    "Last name": "Nazwisko",
    "Phone number": "Telefon",
    "Select category": "Kategoria",
    "Select city": "Miejscowość",
    "Back": "Powrót",
    "Please check your email.": "Proszę sprawdzić email.",
    "We have sent a confirmation email to": "Wysłaliśmy e-maila z potwierdzeniem na adres",
    "Request sent successfully": "Wysłane pomyślnie",
    "Please enter the email address associated with your account and We will email you a link to reset your password.": "Wprowadź adres e-mail powiązany z Twoim kontem. Wyślemy Ci link do zresetowania hasła.",
    "Forgot your password?": "Zapomniałeś hasła?",
    "Reset Password": "Odzyskaj hasło",
    "Email must be a valid email address": "Adres mailowy musi być prawidłowym adresem",
    "There is no user record corresponding to this identifier. The user may have been deleted.": "Adres mailowy nie jest powiązany z żadnym kontem.",
    "Settings": "Ustawienia",
    "Color": "Kolor",
    "Direction": "Kierunek",
    "Fullscreen": "Pełny ekran",
    "To write your first CV - download the application, log in with your data, confirm your phone number and we can start!": "Aby dodać Twoje pierwsze CV i móc w pełni korzystać z naszego serwisu <a target='blanck' href='/apps'>pobierz aplikację</a> i potwierdź swój numer telefonu.",
    "To write your first CV - user": "Aby móc w pełni korzystać z naszego serwisu <a target='blanck' href='/apps'>pobierz aplikację</a> i potwierdź swój numer telefonu. Video CV można również nagrać w przeglądarce na swoim profilu <a href='/dashboard/user/profile/video-cv'>TUTAJ</a>.",
    "Exit Fullscreen": "Wyłączenie trybu pełnoekranowego ",
    "Mode": " Tryb ",
    "Too Short!": " Zbyt krótki",
    "Too Long!": " Zbyt długi",
    "First name required": " Imię wymagane",
    "Last name required":  "Nazwisko wymagane",
    "Email must be a valid email address": "Adres mailowy musi być prawidłowym adresem",
    "Password is required": "Pole wymagane",
    "Phone is required": "Pole wymagane",
    "Register success": "Zarejestrowano pomyślnie",
    "Login success": "Zalogowano pomyślnie",
    "Email must be a valid email address": "Adres mailowy musi być prawidłowym adresem",
    "Check Status Active": "Szukam pracy",
    "Check Profile": " Sprawdzić Profil",
    "Archive": "Archiwum",
    "Vacancy": " Oferta",
    "No action": "Bez akcji",
    "Write salary": "Wpisz wynagrodzenie",
    "Write ID user": "Wpisz ID użytkownika",
    "Go to mail": " Przejdź do e-mail",
    "User added success": "Dodano użytkownika pomyślnie",
    "User deleted success": "Użytkownik usunięty pomyślnie",
    "Links": "Linki",
    "Additional activity": "Aktywność dodatkowa",
    "Interests": "Zainteresowania",
    "Asystent.biz courses": "Szkolenia asystent.biz",
    "Start date": "Data rozpoczęcia",
    "todate": "Data zakończenia",
    "this day": "Obecnie ",
    "Skills": "Umiejętności",
    "Training, courses, certificates": "Szkolenia, kursy, certyfikaty",
    "Level": "poziom",
    "Knowledge of languages": "Znajomość języków",
    "Work experience": "Doświadczenie zawodowe",
    "Update photo": "Zaktualizuj zdjęcie",
    "Email": "E-mail",
    "Phone": "Telefon",
    "Education": "Wykształcenie",
    "Kierunek": "Kierunek",
    "this day": "obecnie",
    "Specjalizacja": "Specjalizacja",
    "Poziom wykształcenia": "Poziom wykształcenia",
    "Opis stanowiska": "Opis stanowiska",
    "Szkolenia, kursy, certyfikaty": "Szkolenia, kursy, certyfikaty",
    "Zaktualizuj CV": "Zaktualizuj CV",
    "Confirm to delete": "Uwaga!",
    "Confirm to verify": "Uwaga!",
    "Are you sure to do this?": "Czy na pewno usunąć?",
    "Are you sure to do this video?": "Czy na pewno usunąć video?",
    "Are you sure to verify the phone number?": "Czy na pewno zweryfikowałeś numer telefonu?",
    "Nie podana": "Nie podana",
    "Delete video": "Usuń film",
    "Verify phone": "Zweryfikuj telefon",
    "Phone is verified": "Telefon jest zweryfikowany",
    "User video deleted success": "Udało się usunąć film użytkownika",
    "my_resume": "Prześlij CV",
    "Use my CV to display on my employer page": "Użyj przesłanego CV na mojej stronie",
    "Download": "Ściągnij",
    "You have not uploaded your resume yet.": "Nie przesłałeś jeszcze swojego CV.",
    "ApprowedFileType": "Dozwolone pliki do przesłania - .pdf/.docx",
    "ApprowedFileSize": "Maksymalny rozmiar pliku nie powinien przekraczać 10 MB. Twój plik",
    "CV": "CV",
    
    "Nazwa uczelni/szkoły": "Nazwa uczelni/szkoły",
    "Data rozpoczęcia": "Data rozpoczęcia",
    "Data zakończenia": "Data zakończenia",
    "obecnie": "obecnie",
    "Doświadczenie zawodowe": "Doświadczenie zawodowe",
    "Firma": "Firma",
    "Stanowisko": "Stanowisko",
    "Znajomość języków": "Znajomość języków",
    "Język": "Język",
    "Poziom": "Poziom",
    "Umiejętności": "Umiejętności",
    "Wpisz swoje umiejętności": "Wpisz swoje umiejętności",
    "Nazwa": "Nazwa",
    "Data uczestnictwa": "Data uczestnictwa",
    "Szkolenia asystent.biz": "Szkolenia asystent.biz",
    "Aktywność dodatkowa": "Aktywność dodatkowa",
    "Wpisz dodatkowe aktywności": "Wpisz dodatkowe aktywności",
    "Wpisz swoje zainteresowania": "Wpisz swoje zainteresowania",
    "Zainteresowania": "Zainteresowania",
    "Linki": "Linki",
    "Adres URL": "Adres URL",
    "Zapisz zmiany": "Zapisz zmiany",
    "Activity": "Aktywność",
    "Application": "Aplikacja",

    "Start": "Start",
    "Dla pracodawcy": "Dla pracodawcy",
    "Blog": "Blog",
    "FAQs": "FAQs",
    "Kontakt": "Kontakt",
    "Oferty pracy": "Oferty pracy",
    "Dołącz do nas": "Dołącz do nas",
    "Pobierz aplikację": "Pobierz aplikację",
    "Regulamin korzystania z usług": "Regulamin korzystania z usług",
    "Polityka prywatności": "Polityka prywatności",
    "Informacja o cookies": "Informacja o cookies",
    "Jak nagrać video CV": "Jak nagrać video CV",
    "Oferty pracy": "Oferty pracy",
    "O nas": "O nas",
    "Szkolenia": "Szkolenia",
    "Informacje zostały zebrane z otwartych źródeł, przetworzone przez naszych specjalistów i opublikowane na stronie. Wszelkie ponowne publikacje są dozwolone, ponieważ dzielimy się wiedzą – a wiedza dla tych, którzy chcą wiedzieć, powinna być dostępna.": "Informacje zostały zebrane z otwartych źródeł, przetworzone przez naszych specjalistów i opublikowane na stronie. Wszelkie ponowne publikacje są dozwolone, ponieważ dzielimy się wiedzą – a wiedza dla tych, którzy chcą wiedzieć, powinna być dostępna.",
    "Dołącz do społeczności asystent.biz": "Dołącz do społeczności asystent.biz",
    "Z łatwością stwórz swoje video CV online": "Z łatwością stwórz swoje video CV online",
    "za pomocą naszej aplikacji": "za pomocą naszej aplikacji",
    "Wypełnij klasyczne CV i otrzymaj ofertę pracy": "Wypełnij klasyczne CV i otrzymaj ofertę pracy",
    "zgodnie ze swoimi oczekiwaniami": "zgodnie ze swoimi oczekiwaniami",
    "© 2021-2022 asystent.biz • All rights reserved": "© 2021-2022 asystent.biz • Wszelkie prawa zastrzeżone",
    "Info": "Info",
    "MENU": "MENU",
    "Rozpocznij pracę": "Rozpocznij pracę",
    "jako asystent razem z zespołem": "jako asystent razem z zespołem",
    "Bezpłatne szkolenia i oferty pracy. Punkt wyjściowy Twojej kariery": "Bezpłatne szkolenia i oferty pracy. Punkt wyjściowy Twojej kariery",
    "Otrzymuj informacje o nowych ofertach bezpośrednio w aplikacji na telefon": " Otrzymuj informacje o nowych ofertach bezpośrednio w aplikacji na telefon",
    "Pobierz teraz": "Pobierz teraz",
    "Nauczymy Cię": "Nauczymy Cię",
    "być jak najbardziej skutecznym w pracy. Z nami znajdziesz stanowisko asystenta, co daje dobre perspektywy zawodowe.": "być jak najbardziej skutecznym w pracy. Z nami znajdziesz stanowisko asystenta, co daje dobre perspektywy zawodowe.",
    "Stwórz swoje CV": "Stwórz swoje CV",
    "W naszym serwisie możesz stworzyć swoje CV, nagrać wideo CV, wziąć udział w bezpłatnych szkoleniach.": "W naszym serwisie możesz stworzyć swoje CV, nagrać wideo CV, wziąć udział w bezpłatnych szkoleniach.",
    "Znajdziemy Ci pracę": "Znajdziemy Ci pracę",
    "U nas proces poszukiwania pracy jest maksymalnie wygodny i efektywny. Dołącz do nas jeszcze dziś.": "U nas proces poszukiwania pracy jest maksymalnie wygodny i efektywny. Dołącz do nas jeszcze dziś.",
    "Dowiedz się, w czym możemy być pomocni": "Dowiedz się, w czym możemy być pomocni",
    "Dla Kandydata": "Dla Kandydata",
    "Na naszej platformie możesz stworzyć CV, a prosta aplikacja mobilna pomoże Ci nagrać wideo CV, do którego link jest zintegrowany z plikiem klasycznego CV. Taka struktura pozwala przedstawić wyczerpujące informacje o sobie i zoptymalizować proces rekrutacyjny. Osobom poszukującym pracy oferujemy bezpłatne materiały szkoleniowe dotyczące skutecznego wyszukiwania informacji w internecie, a także kursy doskonalące ich umiejętności w zakresie takich programów, jak: Microsoft Office, Kalendarz Google, Trello. Informacje o nowych ofertach pracy pojawią się bezpośrednio na telefonie, a proces rekrutacyjny jest tak prosty, na ile to możliwe. Rejestracja i korzystanie z serwisu asystent.biz są całkowicie bezpłatne dla osób poszukujących pracy.": "Na naszej platformie możesz stworzyć CV, a prosta aplikacja mobilna pomoże Ci nagrać wideo CV, do którego link jest zintegrowany z plikiem klasycznego CV. Taka struktura pozwala przedstawić wyczerpujące informacje o sobie i zoptymalizować proces rekrutacyjny. Osobom poszukującym pracy oferujemy bezpłatne materiały szkoleniowe dotyczące skutecznego wyszukiwania informacji w internecie, a także kursy doskonalące ich umiejętności w zakresie takich programów, jak: Microsoft Office, Kalendarz Google, Trello. Informacje o nowych ofertach pracy pojawią się bezpośrednio na telefonie, a proces rekrutacyjny jest tak prosty, na ile to możliwe. Rejestracja i korzystanie z serwisu asystent.biz są całkowicie bezpłatne dla osób poszukujących pracy.",
    "Powierz nam wybór kandydatów do pracy w Twojej firmie. Z nami poszukiwanie pracowników będzie dla Ciebie proste i skuteczne.  Specjalizujemy się w rekrutacji na stanowiska asystenckie: asystent zarządu, asystent do spraw personalnych, asystent prawnika, asystent biurowy, koordynator biura, office manager, asystentka,  recepcjonistka,  sekretarka, asystent wsparcia biznesu. Gwarantujemy, że  przedstawieni przez nas kandydaci spełnią Twoje oczekiwania i potrzeby. Współpracując z nami oszczędzasz czas. Jak możemy pomóc Tobie? Kompleksowo przeprowadzimy rekrutację kandydatów na wskazane stanowisko, opracujemy treść oferty pracy i opublikujemy na portalach ogłoszeniowych oraz social media, przeprowadzimy pełną selekcję kandydatów, zadzwonimy do wybranych, którzy będą spełniać oczekiwania i umówimy ich na rozmowę kwalifikacyjną.": "Powierz nam wybór kandydatów do pracy w Twojej firmie. Z nami poszukiwanie pracowników będzie dla Ciebie proste i skuteczne.  Specjalizujemy się w rekrutacji na stanowiska asystenckie: asystent zarządu, asystent do spraw personalnych, asystent prawnika, asystent biurowy, koordynator biura, office manager, asystentka,  recepcjonistka,  sekretarka, asystent wsparcia biznesu. Gwarantujemy, że  przedstawieni przez nas kandydaci spełnią Twoje oczekiwania i potrzeby. Współpracując z nami oszczędzasz czas. Jak możemy pomóc Tobie? Kompleksowo przeprowadzimy rekrutację kandydatów na wskazane stanowisko, opracujemy treść oferty pracy i opublikujemy na portalach ogłoszeniowych oraz social media, przeprowadzimy pełną selekcję kandydatów, zadzwonimy do wybranych, którzy będą spełniać oczekiwania i umówimy ich na rozmowę kwalifikacyjną.",
    "JESTEŚ PRACODAWCĄ?": "JESTEŚ PRACODAWCĄ?",
    "Obszerna baza kandydatów": "Obszerna baza kandydatów",
    "Głównym zasobem firmy są ludzie. Według statystyk, aby znaleźć jednego odpowiedniego pracownika, należy wyselekcjonować i ocenić co najmniej 100 osób. Bierzemy na siebie pełną odpowiedzialność za to zadanie. Zapoznaj się ze szczegółowymi informacjami oraz naszą ofertą.": "Głównym zasobem firmy są ludzie. Według statystyk, aby znaleźć jednego odpowiedniego pracownika, należy wyselekcjonować i ocenić co najmniej 100 osób. Bierzemy na siebie pełną odpowiedzialność za to zadanie. Zapoznaj się ze szczegółowymi informacjami oraz naszą ofertą.",
    "Więcej": "Więcej",
    "Dołącz do nas i uzyskaj dostęp do wszystkich usług platformy": "Dołącz do nas i uzyskaj dostęp do wszystkich usług platformy",
    "Rejestracja": "Rejestracja",
    "Piękny, nowoczesny i wygodny interfejs użytkownika": "Piękny, nowoczesny i wygodny interfejs użytkownika",
    "Nasza aplikacja": "Nasza aplikacja",
    "Video CV recorder": "Video CV recorder",
    "jest częścią serwisu rekrutacji asystentów i została stworzona do nagrywania wideo CV w formie odpowiedzi na pytania pracodawcy.": "jest częścią serwisu rekrutacji asystentów i została stworzona do nagrywania wideo CV w formie odpowiedzi na pytania pracodawcy.",
    "Konakt": "Konakt",
    "Polska": "Polska",
    "ul. Hoża 86/210": "ul. Hoża 86/210",
    "Warszawa": "Warszawa",
    "Gdzie": "Gdzie",
    "nas": "nas",
    "znaleźć?": "znaleźć?",
    "Faqs": "Faqs",
    "Frequently asked questions": "Często Zadawane Pytania",
    "Jak działa serwis asystent.biz?": "Jak działa serwis asystent.biz?",
    "faq1": "Nasza strona internetowa to platforma oferująca nowoczesne narzędzia rekrutacyjne online, zapewniająca skuteczną pomoc i wsparcie w nawiązywaniu kontaktów pomiędzy pracodawcami a osobami poszukującymi pracy. Ubieganie się o wakaty jest interaktywne, szybkie i tak łatwe dla użytkownika, jak to tylko możliwe.<br><br>Publikujemy oferty pracy od pracodawców, a kandydaci otrzymują informacje o takich wakatach na telefon w formie powiadomień i mogą je przeglądać w naszej aplikacji asystent.biz.<br><br>Ponadto oferujemy szerokie wsparcie kandydatom przed zatrudnieniem. Obejmuje to szkolenia zaawansowane, możliwość stworzenia CV w naszym serwisie, a także wyjątkową możliwość nagrania video CV w formie odpowiedzi na pytania. Korzystanie z naszego systemu jest bezpłatne dla kandydatów.<br><br>Aby w pełni korzystać ze świadczonych przez nas usług, kandydaci muszą najpierw zarejestrować się i zainstalować aplikację mobilną do nagrywania video CV.",
    "Z jakich narzędzi mogę skorzystać w moim Profilu Kandydata?": "Z jakich narzędzi mogę skorzystać w moim Profilu Kandydata?",
    "W sekcji Profil Kandydata możesz wypełnić informację o sobie, stworzyć CV, obejrzeć CV nagrane w aplikacji.": "W sekcji Profil Kandydata możesz wypełnić informację o sobie, stworzyć CV, obejrzeć CV nagrane w aplikacji.",
    "Dla kandydatów poszukujących pracy nasz serwis jest całkowicie bezpłatny.": "Dla kandydatów poszukujących pracy nasz serwis jest całkowicie bezpłatny.",
    "Przejdź do strony <a href='/apps'>Pobierz aplikację</a> na dole ekranu. Wybierz odpowiedni system operacyjny i zainstaluj aplikację z marketu. Aby potwierdzić rejestrację, będziesz potrzebować aktywnego numeru telefonu i adresu e-mail.": "Przejdź do strony <a href='/apps'>Pobierz aplikację</a> na dole ekranu. Wybierz odpowiedni system operacyjny i zainstaluj aplikację z marketu. Aby potwierdzić rejestrację, będziesz potrzebować aktywnego numeru telefonu i adresu e-mail.",
    "Wszystko jest bardzo proste! Kliknij „Zapomniałeś hasła?” na stronie lub w aplikacji, wpisz swój adres e-mail i uzyskaj link do zresetowania hasła. W razie pytań śmiało pisz na <a href='mailto:support@asystent.biz'>support@asystent.biz</a>": "Wszystko jest bardzo proste! Kliknij „Zapomniałeś hasła?” na stronie lub w aplikacji, wpisz swój adres e-mail i uzyskaj link do zresetowania hasła. W razie pytań śmiało pisz na <a href='mailto:support@asystent.biz'>support@asystent.biz</a>",
    "Dane osobowe podane przez Ciebie przetwarzamy w celu świadczenia usług, takich jak założenie konta oraz prowadzenie rekrutacji na różne stanowiska pracy. W każdym momencie możesz usunąć konto wraz z danymi prywatnymi. Więcej znajdziesz w Polityce Prywatności.": "Dane osobowe podane przez Ciebie przetwarzamy w celu świadczenia usług, takich jak założenie konta oraz prowadzenie rekrutacji na różne stanowiska pracy. W każdym momencie możesz usunąć konto wraz z danymi prywatnymi. Więcej znajdziesz w Polityce Prywatności.",
    "Nasze kursy są całkowicie bezpłatne. Nauczymy Cię sprawnie korzystać z takich programów, jak: Microsoft Office, Kalendarz Google, Trello. Dodatkowo prowadzimy szkolenia skutecznego wyszukiwania informacji w internecie. Aby dołączyć do naszych zajęć online, po prostu przejdź na stronę: SZKOLENIA. Jeżeli masz dodatkowe pytania, pisz na school@asystent.biz.": "Nasze kursy są całkowicie bezpłatne. Nauczymy Cię sprawnie korzystać z takich programów, jak: Microsoft Office, Kalendarz Google, Trello. Dodatkowo prowadzimy szkolenia skutecznego wyszukiwania informacji w internecie. Aby dołączyć do naszych zajęć online, po prostu przejdź na stronę: SZKOLENIA. Jeżeli masz dodatkowe pytania, pisz na school@asystent.biz.",
    "Nie. W naszym systemie wszystkie oferty pracy pojawiają się w wiadomościach do aplikacji i na koncie osobistym. Jeśli masz dodatkowe pytania dotyczące konkretnego wakatu, napisz na <a href='mailto:asystent@asystent.biz'>asystent@asystent.biz</a>, podając ID oferty pracy.": "Nie. W naszym systemie wszystkie oferty pracy pojawiają się w wiadomościach do aplikacji i na koncie osobistym. Jeśli masz dodatkowe pytania dotyczące konkretnego wakatu, napisz na <a href='mailto:asystent@asystent.biz'>asystent@asystent.biz</a>, podając ID oferty pracy.",
    "W swoim profilu w aplikacji lub serwisie internetowym kliknij „Usuń profil” i postępuj zgodnie z instrukcjami. Twój profil i wszystkie dane osobowe zostaną usunięte po potwierdzeniu przez moderatora.": "W swoim profilu w aplikacji lub serwisie internetowym kliknij „Usuń profil” i postępuj zgodnie z instrukcjami. Twój profil i wszystkie dane osobowe zostaną usunięte po potwierdzeniu przez moderatora.",
    "W jaki sposób mogę wyrejestrować się z serwisu?": "W jaki sposób mogę wyrejestrować się z serwisu?",
    "Czy mogę wyszukać ofertę pracy w serwisie asystent.biz?": "Czy mogę wyszukać ofertę pracy w serwisie asystent.biz?",
    "Czy udział w szkoleniach po wprowadzeniu do zawodu asystenta jest płatny?": "Czy udział w szkoleniach po wprowadzeniu do zawodu asystenta jest płatny?",
    "Aktualizacja aplikacji do najnowszej wersji.": "Aktualizacja aplikacji do najnowszej wersji.",
    "Pytania bez odpowiedzi – jak mogę skontaktować się z pomocą techniczną?": "Pytania bez odpowiedzi – jak mogę skontaktować się z pomocą techniczną?",
    "Prywatność mojego konta.": "Prywatność mojego konta.",
    "Zgubiłem hasło – jak mogę przywrócić dostęp do mojego konta?": "Zgubiłem hasło – jak mogę przywrócić dostęp do mojego konta?",
    "Jak zainstalować aplikację asystent.biz w telefonie?": "Jak zainstalować aplikację asystent.biz w telefonie?",
    "Ile zapłacę za korzystanie z systemu, jeśli szukam pracy?": "Ile zapłacę za korzystanie z systemu, jeśli szukam pracy?",
    "W": "W",
    "czym": "czym",
    "możemy": "możemy",
    "Ci": "Ci",
    "pomóc?": "pomóc?",
    "News": "Aktualności",
    "404 Post not found": "404 Nie znaleziono wpisu",
    "Recent posts": "Recent posts",
    "Poznaj": "Poznaj",
    "nasze": "nasze",
    "usługi!": "usługi!",
    "Znajdujemy": "Znajdujemy",
    "najlepszych kandydatów": "najlepszych kandydatów",
    "do pracy": "do pracy",
    "ale do zaoferowania mamy o wiele więcej.": "ale do zaoferowania mamy o wiele więcej.",
    "Powierz nam rekrutację i dobór kandydatów w Twojej firmie.": "Powierz nam rekrutację i dobór kandydatów w Twojej firmie.",
    "Poszukiwanie pracowników z nami będzie dla Ciebie proste i skuteczne.": "Poszukiwanie pracowników z nami będzie dla Ciebie proste i skuteczne.",
    "Nasi kandydaci spełnią Twoje oczekiwania i potrzeby.": "Nasi kandydaci spełnią Twoje oczekiwania i potrzeby.",
    "Poznaj naszą ofertę": "Poznaj naszą ofertę",
    "Specjalizujemy się w rekrutacji na stanowiska asystenckie": "Specjalizujemy się w rekrutacji na stanowiska asystenckie",
    "Asystent zarządu": "Asystent zarządu",
    "Asystent personalny": "Asystent personalny",
    "Asystent prawnika": "Asystent prawnika",
    "Asystent biurowy, ​Koordynator biura​, ​Office manager​": "Asystent biurowy, ​Koordynator biura​, ​Office manager​",
    "Asystentka​,​ recepcjonistka, ​sekretarka": "Asystentka​,​ recepcjonistka, ​sekretarka",
    "Asystent wsparcia biznesu": "Asystent wsparcia biznesu",
    "Podstawowe warunki współpracy oraz zakres usług": "Podstawowe warunki współpracy oraz zakres usług",
    "kompleksowe przeprowadzenie rekrutacji kandydatów na wskazane stanowisko": "kompleksowe przeprowadzenie rekrutacji kandydatów na wskazane stanowisko",
    "opracowanie treści oferty pracy zgodnie z wymaganiami Pracodawcy": "opracowanie treści oferty pracy zgodnie z wymaganiami Pracodawcy",
    "publikacja oferty pracy na portalach ogłoszeniowych i social media": "publikacja oferty pracy na portalach ogłoszeniowych i social media",
    "selekcja kandydatów": "selekcja kandydatów",
    "weryfikacja kandydatów pod względem oczekiwanych kwalifikacji": "weryfikacja kandydatów pod względem oczekiwanych kwalifikacji",
    "przeprowadzenie rozmów kwalifikacyjnych telefonicznie i online": "przeprowadzenie rozmów kwalifikacyjnych telefonicznie i online",
    "inicjowanie i koordynowanie spotkań pracodawcy z kandydatami": "inicjowanie i koordynowanie spotkań pracodawcy z kandydatami",
    "Opłata „Na Start” 600 PLN/netto": "Opłata „Na Start” 600 PLN/netto",
    "określenie potrzeb rekrutacyjnych Pracodawcy": "określenie potrzeb rekrutacyjnych Pracodawcy",
    "analiza bazy Kandydatów": "analiza bazy Kandydatów",
    "publikacja ogłoszeń na portalach i w mediach": "publikacja ogłoszeń na portalach i w mediach",
    "poszukiwania bezpośrednie": "poszukiwania bezpośrednie",
    "selekcja, weryfikacja, przedstawienie kandydatur": "selekcja, weryfikacja, przedstawienie kandydatur",
    "Chcesz poznać więcej szczegółów? Zapytać o ofertę?": "Chcesz poznać więcej szczegółów? Zapytać o ofertę?",
    "Śmiało, napisz do nas!": "Śmiało, napisz do nas!",
    "Succes Fee": "Succes Fee",
    "2000 PLN/netto opłata jednorazowa za pozyskanie jednego pracownika, płatne 7 dni po rozpoczęciu pracy przez kandydata": "2000 PLN/netto opłata jednorazowa za pozyskanie jednego pracownika, płatne 7 dni po rozpoczęciu pracy przez kandydata",
    "Gwarancja 1 miesiąc": "Gwarancja 1 miesiąc",
    "Jeśli w ciągu miesiąca gwarancyjnego, pracownik zrezygnuje z pracy, lub okaże się nieodpowiedni,": "Jeśli w ciągu miesiąca gwarancyjnego, pracownik zrezygnuje z pracy, lub okaże się nieodpowiedni,",
    "skieruje do Pracodawcy kolejnego kandydata o podobnym profilu lub zwróci opłatę Succes Fee": "skieruje do Pracodawcy kolejnego kandydata o podobnym profilu lub zwróci opłatę Succes Fee",
    "Tutaj znajdziesz nasz Regulamin współpracy": "Tutaj znajdziesz nasz Regulamin współpracy",
    "w kwestiach rekrutacji pracowników": "w kwestiach rekrutacji pracowników",
    "Zamów rekrutację": "Zamów rekrutację",
    "App": "App",
    "IOS": "IOS",
    "Android": "Android",
    "Zainstaluj asystent.biz na iPhone'a": "Zainstaluj asystent.biz na iPhone'a",
    "Zainstaluj asystent.biz na Androida": "Zainstaluj asystent.biz na Androida",
    "Aplikacja": "Aplikacja",
    "jest częścią serwisu rekrutacji asystentów i została stworzona do nagrywania video CV w formie odpowiedzi na pytania pracodawcy. Jest to oficjalną aplikacją mobilną naszego portalu. Lista pytań, na które należy odpowiedzieć, została starannie dobrana przez zespół HR.": "jest częścią serwisu rekrutacji asystentów i została stworzona do nagrywania video CV w formie odpowiedzi na pytania pracodawcy. Jest to oficjalną aplikacją mobilną naszego portalu. Lista pytań, na które należy odpowiedzieć, została starannie dobrana przez zespół HR.",
    "Dla kandydatów poszukujących pracy korzystanie z aplikacja jest bezpłatne.": "Dla kandydatów poszukujących pracy korzystanie z aplikacja jest bezpłatne.",
    "Główną zaletą video CV jest to, że możesz nagrać je ponownie. W przeciwieństwie do osobistego spotkania tutaj masz prawo do błędu. Pytania, na które będziesz odpowiadać, pojawią się już w trakcie nagrywania, ale możesz wcześniej się do nich przygotować.": "Główną zaletą video CV jest to, że możesz nagrać je ponownie. W przeciwieństwie do osobistego spotkania tutaj masz prawo do błędu. Pytania, na które będziesz odpowiadać, pojawią się już w trakcie nagrywania, ale możesz wcześniej się do nich przygotować.",
    "Video CV jest już gotowe, co dalej?": "Video CV jest już gotowe, co dalej?",
    "Dalej wszystko jest bardzo proste. Zapisz je i udostępnij do wyszukiwania. W naszym serwisie możesz również stworzyć i zapisać klasyczne tekstowe CV, a link do filmiku znajdzie się bezpośrednio w jego treści, co znacznie ułatwi pracodawcy zapoznanie się z Twoją kandydaturą.": "Dalej wszystko jest bardzo proste. Zapisz je i udostępnij do wyszukiwania. W naszym serwisie możesz również stworzyć i zapisać klasyczne tekstowe CV, a link do filmiku znajdzie się bezpośrednio w jego treści, co znacznie ułatwi pracodawcy zapoznanie się z Twoją kandydaturą.",
    "Dobrze przygotowany film, pewność siebie i poprawne mówienie pomogą Ci wywrzeć pozytywne wrażenie na pracodawcy i zdobyć wymarzoną pracę.": "Dobrze przygotowany film, pewność siebie i poprawne mówienie pomogą Ci wywrzeć pozytywne wrażenie na pracodawcy i zdobyć wymarzoną pracę.",
    "Zrób to, a odniesiesz sukces!": "Zrób to, a odniesiesz sukces!",
    "Powodzenia!": "Powodzenia!",
    "Courses": "Kursy",
    "Szkolenia": "Szkolenia",
    "gratis": "gratis",
    "Pracujmy razem i osiągnijmy": "Pracujmy razem i osiągnijmy",
    "niesamowite rezultaty.": "niesamowite rezultaty.",
    "Czego chcemy Cię nauczyć?": "Czego chcemy Cię nauczyć?",
    "W pracy asystenta ważną rolę odgrywają narzędzia, za pomocą których można sprawniej wykonywać powierzone mu zadania. Wybraliśmy główne obszary, które zalecamy opanować, jeśli planujesz pracować jako personalny asystent. Microsoft Word – edytor dokumentów i tekstów, przeznaczony do tworzenia, przeglądania, edycji i formatowania tekstów, dokumentów biznesowych, a także innych dokumentów. Microsoft Excel – wiodący w branży program do obsługi arkuszy kalkulacyjnych, potężne narzędzie do wizualizacji i analizy danych. Kalendarz Google – usługa planowania spotkań, wydarzeń i spraw. Umożliwia ustawianie przypomnień i godzin spotkań, pozwala na zapraszanie innych uczestników za pomocą powiadomień e-mail. Trello – oprogramowanie do zarządzania projektami w chmurze dla małych zespołów. Może pomóc w zorganizowaniu wszystkiego: od etapów dużego projektu po małe zadania. Skuteczne wyszukiwanie informacji w internecie – dla większości użytkowników nie jest już tajemnicą, że w internecie można znaleźć prawie każdą informację. Ale niewiele osób wie, jak poprawnie ją wyszukiwać. Nauczymy Cię tego.": "W pracy asystenta ważną rolę odgrywają narzędzia, za pomocą których można sprawniej wykonywać powierzone mu zadania. Wybraliśmy główne obszary, które zalecamy opanować, jeśli planujesz pracować jako personalny asystent. Microsoft Word – edytor dokumentów i tekstów, przeznaczony do tworzenia, przeglądania, edycji i formatowania tekstów, dokumentów biznesowych, a także innych dokumentów. Microsoft Excel – wiodący w branży program do obsługi arkuszy kalkulacyjnych, potężne narzędzie do wizualizacji i analizy danych. Kalendarz Google – usługa planowania spotkań, wydarzeń i spraw. Umożliwia ustawianie przypomnień i godzin spotkań, pozwala na zapraszanie innych uczestników za pomocą powiadomień e-mail. Trello – oprogramowanie do zarządzania projektami w chmurze dla małych zespołów. Może pomóc w zorganizowaniu wszystkiego: od etapów dużego projektu po małe zadania. Skuteczne wyszukiwanie informacji w internecie – dla większości użytkowników nie jest już tajemnicą, że w internecie można znaleźć prawie każdą informację. Ale niewiele osób wie, jak poprawnie ją wyszukiwać. Nauczymy Cię tego.",
    "Dołącz do naszych kursów": "Dołącz do naszych kursów",
    "Link has no active": "Link jest nieaktywny",
    "Status: Oferta pracy wygasła -": "Status: Oferta pracy wygasła -",
    "Dodana": "Dodana",
    "404 Przepraszamy, strony nie znaleziono": "404 Przepraszamy, strony nie znaleziono",
    "Przepraszamy, strony nie znaleziono!": "Przepraszamy, strony nie znaleziono!",
    "Nie mogliśmy znaleźć strony, której szukasz. Być może błędnie wpisałeś adres URL?": "Nie mogliśmy znaleźć strony, której szukasz. Być może błędnie wpisałeś adres URL?",
    "Sprawdź pisownię i spróbuj ponownie.": "Sprawdź pisownię i spróbuj ponownie.",
    "Go to Home": "Przejdź do strony głównej",
    "500 wewnętrzny błąd serwera": "500 wewnętrzny błąd serwera",
    "Wystąpił błąd, spróbuj ponownie później.": "Wystąpił błąd, spróbuj ponownie później.",
    "": "",
}

export default lang